(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("ArcWeuiVueV1", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["ArcWeuiVueV1"] = factory(require("vue"));
	else
		root["ArcWeuiVueV1"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_228__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition